import { t } from 'i18next';
import z from 'zod';
import type { ConfirmPasswordApiRequest, ConfirmTwoFactorApiRequest } from '../types';

export const confirmTwoFactorCodeFormSchema = z
  .object({
    code: z
      .string()
      .min(1, t('features:account.components.enable_two_factor_flow.errors.code_required'))
      .regex(
        /^\d{6}$/,
        t('features:account.components.enable_two_factor_flow.errors.code_invalid'),
      ),
  })
  .transform((data) => {
    return {
      code: data.code,
    } satisfies ConfirmTwoFactorApiRequest;
  });

type ConfirmTwoFactorCodeFormSchema = typeof confirmTwoFactorCodeFormSchema;

export type ConfirmTwoFactorCodeFormState = z.input<ConfirmTwoFactorCodeFormSchema>;

export const confirmPasswordFormSchema = z
  .object({
    password: z
      .string()
      .min(1, t('features:account.components.confirm_password_modal.errors.password_required')),
  })
  .transform((data) => {
    return {
      password: data.password,
    } satisfies ConfirmPasswordApiRequest;
  });

type ConfirmPasswordFormSchema = typeof confirmPasswordFormSchema;

export type ConfirmPasswordFormState = z.input<ConfirmPasswordFormSchema>;
